"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceLink = exports.getTargetProps = exports.getReferenceTarget = void 0;
const getReferenceTarget = (target) => {
    switch (target.type) {
        case 'link':
            return target.link || target.target;
        case 'page-folder':
            return target.pageFolder._url;
        default:
            //Log.warn('Reference ', target, ' is not valid reference')
            return '/';
    }
};
exports.getReferenceTarget = getReferenceTarget;
function getTargetProps(target) {
    if (target.openInNewWindow) {
        return {
            target: '_blank',
            rel: 'noopener',
        };
    }
    return {};
}
exports.getTargetProps = getTargetProps;
const ReferenceLink = (props) => {
    const { component } = props;
    const singularValue = Array.isArray(props.link) ? props.link[0] : props.link;
    const href = (0, exports.getReferenceTarget)(singularValue.reference ?? singularValue);
    const targetProps = getTargetProps(singularValue.reference ?? singularValue);
    return component({ text: singularValue?.name, href, ...targetProps });
};
exports.ReferenceLink = ReferenceLink;
